"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../../api/ApplicationContext");
var _ConsultantTable = _interopRequireDefault(require("../ConsultantTable"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class RunasUserSelectionStep extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleDisableButton", data => {
      if (data.isbtnDisabled === '' || data.isbtnDisabled === false) {
        this.setState({
          disableSave: false
        });
      } else {
        this.setState({
          disableSave: true
        });
      }
    });
    _defineProperty(this, "onSubmitConsultant", () => {
      this.consultantChild.current.onSubmitForm();
    });
    _defineProperty(this, "onCancelForm", () => {
      window.postMessage({
        runAsModal: false
      });
      const {
        history
      } = this.props;
      history.push(_ApplicationContext.ApplicationContext.getLoginPath());
    });
    this.consultantChild = /*#__PURE__*/_react.default.createRef();
    this.state = {
      isLoading: false,
      resendRequested: false,
      otpCode: '',
      errorMessage: '',
      additionalData: null,
      disableSave: true
    };
    this.el = document.createElement('div');
    this.el.style.display = 'contents';
  }
  componentDidMount() {
    document.body.appendChild(this.el);
  }
  componentWillUnmount() {
    document.body.removeChild(this.el);
  }
  render() {
    const {
      stepResponse
    } = this.props;
    const {
      disableSave
    } = this.state;
    return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_core.Modal, {
      showCloseIcon: true,
      darkBackground: true,
      fullWidth: true,
      closeModalCallback: this.onCancelForm,
      footer: /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        className: "is-size-4",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("b", null, "Status:"), " A=Active, fully registered / R=Requested, access is not set up (links expire after ", /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: 'red'
        }
      }, stepResponse?.additionalData?.settingsMap?.TokenTimeOut, " days "), ")/ D=Deactivated (deactivation occurs if no logins for ", /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: 'red'
        }
      }, stepResponse?.additionalData?.settingsMap?.InactiveDeactivateMonths / 12, " year "), ")"), /*#__PURE__*/_react.default.createElement(_core.Button, {
        className: "is-primary fixedButtonSize",
        handleClick: this.onCancelForm
      }, "Cancel"), /*#__PURE__*/_react.default.createElement(_core.Button, {
        className: "is-primary is-pulled-right fixedButtonSize",
        handleClick: this.onSubmitConsultant,
        disabled: disableSave
      }, "Next")),
      header: "Please select a consultant"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.ErrorBoundry, null, /*#__PURE__*/_react.default.createElement(_ConsultantTable.default, {
      ref: this.consultantChild,
      consultants: stepResponse?.additionalData?.consultants,
      buttonTypeonChange: this.handleDisableButton,
      listener: this.props.listener
    })))), this.el);
  }
}
RunasUserSelectionStep.propTypes = {
  listener: _propTypes.default.func.isRequired,
  stepResponse: _propTypes.default.any,
  history: _propTypes.default.any
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(RunasUserSelectionStep);
//# sourceMappingURL=RunasUserSelectionStep.js.map